import { TextField } from "@mui/material";
import { forwardRef } from "react";
import { useController } from "react-hook-form";

const CustomNumberField = forwardRef(({ field, control }, ref) => {
  const { field: fieldProps, fieldState } = useController({
    control,
    name: field.name,
  });

  return (
    <TextField
      ref={ref}
      label={field.label}
      variant="outlined"
      fullWidth
      type={"text"}
      helperText={fieldState.error?.message || field.help_text || ""}
      error={!!fieldState.error}
      disabled={field.disabled}
      {...fieldProps}
    />
  );
});

export default CustomNumberField;
